import { loading$, query, value$ } from 'state/Design/query';
import DesignService from 'state/Design/service';
import { type FacadeReturnTypes } from 'utils/modules/state';

export type DesignFacade = FacadeReturnTypes<typeof facade>;

const api = new DesignService();
void api.getDesign();

const facade = {
   api,
   query,
   error$: query.selectError(),
   loading$,
   isLoading$: loading$, // alias
   value$,
   design$: value$, // alias
};

export default facade;
